import {DrawFrmThing} from "../../../drawfrm/DrawFrmThing";
import {inches, lineBlueHeavy} from "../../../const";
import {FrmShape} from "../../../drawfrm/FrmShape";
import {FrameProfileArgs} from "./ProfileArgs";
import {FrmRefPoint} from "../../../drawfrm/FrmRefPoint";

// Cased Open
export class FrameProfileCO extends DrawFrmThing {

    primaryDoorAnchor = new FrmRefPoint();
    // top of the outer face; the frame-profile view aligns a clamshell mullion on this.
    faceAnchor = new FrmRefPoint();

    constructor(args: FrameProfileArgs) {
        super();
        const {detail, jambDepth, jambFace, view, app, left, swingIn, clamshell, hideFaces, hideFaceDims, flipY} = args;

        const shape = new FrmShape(`frameProfile:CO:${left ? "left" : "right"}`, {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: app,
        });
        shape.strokeColor = lineBlueHeavy;
        shape.horizontalDimensionSide = left ? "left" : "right";
        if (!left) shape.invertX();
        if((!swingIn) !== !!flipY) shape.invertY();

        // |-------|
        //         |
        //         |
        //         |
        //         |
        // |-------|

        shape.start(0, 0);

        // indent
        const topIndent = shape.lineTo(0, -4);
        if(clamshell) topIndent.setPenUp();
        else topIndent.linkDimension(detail.topTab, "extended");

        // top face
        const topFace = shape.lineTo(2 * inches, 0);
        topFace.linkDimension(jambFace);

        // throat (jamb depth)
        const upper = shape.lineTo(0, 20);
        const mid = shape.lineTo(0, 20)
            .linkDimension(detail.doorThickness, "extended");
        const lower = shape.lineTo(0, 20);
        upper.dimMatches(lower);

        this.primaryDoorAnchor.setLocalPoint(mid.pointB);

        // bottom face
        const bottomFace = shape.lineTo(-2 * inches, 0);
        bottomFace.dimMatches(topFace); // top face and bottom face must match

        // indent
        const bottomIndent = shape.lineTo(0, -4);
        if(clamshell) bottomIndent.setPenUp();
        else bottomIndent.linkDimension(detail.bottomTab, "extended");

        // setup jamb depth
        shape.addDimension(topFace.getStartpoint(), bottomFace.getEndpoint(), jambDepth);

        // build
        // clamshell secondary side: omit the top/bottom faces so the primary side's
        // faces cap the merged mullion (avoids a doubled/gapped cap).
        if(hideFaces) { topFace.setPenUp(); bottomFace.setPenUp(); }
        if(hideFaces || hideFaceDims) shape.hideDimensionsForVars([jambFace, jambDepth]);
        this.faceAnchor.setLocalPoint(topFace.getStartpoint());
        shape.done();
    }
}
